var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintbucket3 = function SvgPaintbucket3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paintbucket-3_svg__a)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.846 10.999c-.87.83-2.862.187-4.45-1.439-1.587-1.625-2.168-3.616-1.298-4.447m5.748 5.886c.87-.831.289-2.822-1.298-4.448-1.588-1.625-3.58-2.269-4.45-1.438m5.748 5.886-4.944 4.888c-.87.83-2.862.187-4.45-1.438C4.867 12.823 4.285 10.832 5.155 10l4.944-4.888M19.25 17.643c0 .887-.784 1.607-1.75 1.607s-1.75-.72-1.75-1.607c0-.888 1.75-2.893 1.75-2.893s1.75 2.005 1.75 2.893Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paintbucket-3_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "#fff"
  })))));
};

export default SvgPaintbucket3;